import SashiDo from 'lib/SashiDo';
import React, { Component } from 'react';
import TagManager from 'react-gtm-module';
import GoogleTagManager from 'lib/GoogleTagManager';
import { Provider, createStore } from 'dashboard/context';
import ReactDOM from 'react-dom';
import { browserHistory as history } from 'react-router';
import * as Sentry from '@sentry/browser';
import Isvg from 'react-inlinesvg';
import { TooltipPortalProvider } from 'react-autotip';
import 'stylesheets/base.scss';
import { setAvailableParseServerVersions } from 'lib/Constants';

import AccountManager from 'lib/AccountManager';
import AppsManager from 'lib/AppsManager';
import { ThirdPartyApps } from 'lib/ThirdPartyApps';
import LoadingParticles from 'components/LoadingParticles/LoadingParticles.react';
import Routes from './routes';

ThirdPartyApps();

if (process.env.SENTRY_DSN && process.env.ISPRODUCTION) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: "dashboard@0.1.0"
  });
}

window.s = [];

export default class AppView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      navigatorStatus: true,
      isPrivateMode: false,
      currentUser: {},
      currentCustomer: {},
    };

    this.svgsAreLoaded = false;
    this.updateNavigatorStatus = this.updateNavigatorStatus.bind(this);
  }

  async componentDidMount() {
    if (process.env.GOOGLE_TAG_MANAGER_ID) {
      const tagManagerArgs = {
        gtmId: process.env.GOOGLE_TAG_MANAGER_ID,
      };

      TagManager.initialize(tagManagerArgs);
    }

    window.addEventListener('online', status => this.updateNavigatorStatus(status));
    window.addEventListener('offline', status => this.updateNavigatorStatus(status));

    const match = new RegExp('^(/login|/register|/activate|/forgot)').test(window.location.pathname);

    window.Intercom('boot', {
      app_id: process.env.INTERCOM_APP_ID,
    });

    if (!(match)) {
      const { currentUser, currentCustomer, products } = await AccountManager.currentUser();
      if (
        !currentUser ||
        !currentCustomer ||

        // banned users
        (
          currentCustomer.info &&
          currentCustomer.info.cf_bannedblocked &&
          currentCustomer.info.cf_bannedblocked.toLowerCase() === 'yes'
        )
      ) {
        window.location = '/login';
        return null;
      }

      this.intercomeInit(currentUser);
      this.sentryInit(currentUser);

      const { apps } = products;

      apps.forEach((app) => {
        AppsManager.addApp(app);
      });

      this.state.currentUser = currentUser;
      this.state.currentCustomer = currentCustomer;
      this.state.products = products;

      const versionsArr = await SashiDo.getAvailableParseServerVersions();
      setAvailableParseServerVersions(versionsArr);
      this.state.availableParseServerVersions = versionsArr;

      if (process.env.GOOGLE_TAG_MANAGER_ID) {
        const { subscription } = currentCustomer;
        const { status: subscriptionStatus } = subscription;

        GoogleTagManager({
          data: {
            event: 'logged-in-dashboard',
            pageCategory: 'sign-in',
            subscriptionStatus,
          },
        });
      }


      const showInfoBox =
        !currentUser.agreements.privacyPoliciesAcceptedDate ||
        !currentUser.agreements.termsOfServiceAcceptedDate ||
        !currentUser.agreements.privacyNoticeAcceptedDate;

      if (showInfoBox) {
        history.push('/account/legal');
      }
    }

    this.setState({
      loading: false,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.updateNavigatorStatus());
    window.removeEventListener('offline', this.updateNavigatorStatus());
  }


  onSVGLoad = () => {
    this.svgsAreLoaded = true;
  };

  intercomeInit = (currentUser) => {
    const {
      id, name, email, backups_enabled,
    } = currentUser;

    const intercomUser = {
      user_id: id,
      email,
      name: name || email,
      last_login: new Date(),
      backups_enabled,
    };

    window.Intercom('update', { ...intercomUser });
  }

  sentryInit = (currentUser) => {
    // if (process.env.SENTRY_DSN && process.env.ISPRODUCTION) {
    const {
      id, email,
    } = currentUser;

    Sentry.configureScope(function (scope) {
      scope.setUser({
        id,
        email,
      });
    });
    // }
  }

  updateNavigatorStatus(status = {}) {
    this.state.navigatorStatus = status.type === 'online';
    this.state.message = 'No Internet Connection';
    this.forceUpdate();
  }


  render() {
    const props = {
      history,
      currentUser: this.state.currentUser,
      currentCustomer: this.state.currentCustomer,
      products: this.state.products,
      availableParseServerVersions: this.state.availableParseServerVersions,
    };

    let content = this.state.loading ? <LoadingParticles /> : <Routes {...props} />;

    if (!this.state.navigatorStatus || this.state.isPrivateMode) {
      content = <LoadingParticles status={this.state.message} particles={false} />;
    }

    return (
      <Provider value={createStore(this)}>
        {content}
        <Isvg src="/assets/images/sprites.svg" uniquifyIDs={false} cacheGetRequests onLoad={this.onSVGLoad} />
      </Provider>
    );
  }
}

ReactDOM.render(
  <TooltipPortalProvider>
    <AppView />
  </TooltipPortalProvider>,
  document.getElementById('root'),
);
